<template>
  <section>
    <el-collapse v-model="invoices.filtersOpened">
      <el-collapse-item
        :title="$t('common.search')"
        name="invoices-search-section"
        id="invoices-search-section"
      >
        <el-form
          id="invoices-search-section-form"
          class="search-section-form"
          :model="searchForm"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('layout.dateFrom')">
                <el-date-picker
                    class="el-dropdown-new drop-sp date-dob"
                    @change="handleSearch"
                    v-model="searchForm.dateFrom"
                    format="MM/dd/yyyy"
                    :clearable="false"
                    type="date"
                    id="searchForm-dateFrom"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('layout.dateTo')">
                <el-date-picker
                    class="el-dropdown-new drop-sp date-dob"
                    @change="handleSearch"
                    v-model="searchForm.dateTo"
                    format="MM/dd/yyyy"
                    clearable
                    type="date"
                    id="searchForm-dateTo"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('invoices.invoiceNum')">
                <el-input
                    v-model="searchForm.invoiceNumber"
                    v-alphanumeric-validation
                    maxlength="20"
                    clearable
                    @clear="handleSearch"
                    v-on:keyup.enter.native="handleSearch"
                    class="inline-input"
                    ref="filter-invoiceNum"
                    id="searchForm-invoiceNum" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('invoices.amountFrom')">
                <el-input-number
                       v-model="searchForm.amountFrom"
                       class="inline-input width-100p"
                       v-alphanumeric-validation
                       maxlength="10"
                       clearable
                       v-on:keyup.enter.native="handleSearch"
                       :controls="false"
                       :precision="2"
               ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('invoices.amountTo')">
                <el-input-number
                       v-model="searchForm.amountTo"
                       class="inline-input width-100p"
                       v-alphanumeric-validation
                       maxlength="10"
                       clearable
                       v-on:keyup.enter.native="handleSearch"
                       :controls="false"
                       :precision="2"
               ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="text-align-end">
              <el-tooltip
                :content="$t('common.search')"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <el-button
                  id="invoices-search-section-form-button"
                  class="button-action-default"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'InvoicesSearchSection',
  computed: {
    ...mapGetters(['invoices'])
  },
  data() {
    return {
      activeCollapsibleName: ['invoices-search-section'],
      isOpen: ['invoices-search-section'],
      searchForm: {
        dateFrom: Date.now(),
        dateTo: null,
        invoiceNumber: null,
        amountFrom: undefined,
        amountTo: undefined
      }
    };
  },
  watch: {
    'searchForm.dateFrom': function updateFrom(newVal) {
      const newDayOfServiceFrom = moment(newVal);
      if (newDayOfServiceFrom.isAfter(moment(this.searchForm.dateTo))) {
        this.searchForm.dateTo = newVal;
      }
    },
    'searchForm.dateTo': function updateTo(newVal) {
      const newDayOfServiceTo = moment(newVal);
      if (newDayOfServiceTo.isBefore(moment(this.searchForm.dateFrom))) {
        this.searchForm.dateFrom = newVal;
      }
    }
  },
  methods: {
    handleSearch() {
      this.$store.dispatch('invoices/searchMyInvoices', this.searchForm);
      this.$store.dispatch('invoices/setIsInBulkPrinting', false);
    }
  }
};
</script>
